export default {
    login: {
        email: 'Email',
        password: 'Password',
        remember: 'Remember Me',
        connect: 'Login',
        forgotPassword: 'Forgot Your Password?',
        failed: 'These credentials are incorrect.',
        connectToAccount: 'Log into your account',
        error: 'An internal server error occurred',
    },
    twoFactorChallenge: {
        pageTitle: 'Two-factor authentication',
        instructions: 'A verification code has been generated in your authentication app. Please enter the code to continue.',
        invalidCode: 'Invalid verification code.',
        verificationCode: 'Verification code',
        validate: 'Validate',
        useRecoveryCode: 'Use recovery code',
        useOneTimePassword: 'Use one-time password',
    },
    twoFactorSetup: {
        pageTitle: 'Setup two-factor authentication',
        instructions: 'Two-factor authentication is required to keep access to the license manager secure. It must be activated within the 3 first logins.',
        activate: 'Set up now',
        later: 'Later',
        modal: {
            title: 'Two-factor authentication',
            instructions: 'Scan the QR code above with an authentication app such as Google Authenticator.',
            activation: 'Activation',
            recoveryCodes: 'Recovery codes',
            button: 'Complete activation',
        },
    },
    forgotPassword: {
        pageTitle: 'Forgot Password',
        email: 'Email',
        instructions: 'Enter the email address linked to the account for which you would like to reset the password.',
        send: 'Send',
        userNotFound: 'No user is associated to the specified email.',
        invalidEmail: 'The specified email is invalid.',
        unknownError: 'An unknown error occured.',
        emailSentTitle: 'Email sent',
        emailSentText: 'A password reset email has been sent to your email address.',
        passwordFound: 'You found your password?',
    },
    newPassword: {
        pageTitle: 'New password',
        instructions: 'You\'re almost done!<br>Please enter a new password (at least 8 characters).',
        password: 'Password',
        passwordConfirmation: 'Retype password',
        changePassword: 'Change password',
        passwordChanged: 'Your password has been changed successfully.',
    },
};
